<template>
  <FormFieldWrapper :data="data">
    <div class="rating-container">
      <div class="rating-scale">
        <div v-if="data?.leftLabel" class="scale-label left">{{ data.leftLabel }}</div>
        <div class="scale-options">
          <label
            v-for="n in scaleSize"
            :key="n"
            class="scale-option"
          >
            <input
              type="radio"
              :name="`rating-${fieldId}`"
              :value="n"
              :checked="modelValue === n"
              class="radio-input"
              @change="handleChange"
            />
            <span class="radio-custom">
              <span v-if="modelValue === n" class="radio-dot"></span>
            </span>
            <span class="scale-number">{{ n }}</span>
          </label>
        </div>
        <div v-if="data?.rightLabel" class="scale-label right">{{ data.rightLabel }}</div>
      </div>
    </div>
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'Rating',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      fieldId: `rating-${Math.random().toString(36).substr(2, 9)}`
    };
  },
  computed: {
    scaleSize() {
      return this.data?.scaleSize || 5;
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', Number(event.target.value));
    }
  }
};
</script>

<style scoped>
.rating-container {
  width: 100%;
}

.rating-scale {
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.scale-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #333;
  white-space: nowrap;
}

.scale-label.left {
  text-align: right;
  min-width: 60px;
}

.scale-label.right {
  text-align: left;
  min-width: 60px;
}

.scale-options {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.scale-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
}

.radio-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #999;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #004879;
}

.scale-option:hover .radio-custom {
  border-color: #004879;
}

.radio-input:checked + .radio-custom {
  border-color: #004879;
}

.radio-input:checked + .radio-custom .radio-dot {
  background: #004879;
}

.scale-option:hover .radio-input:checked + .radio-custom {
  border-color: #1E4670;
}

.scale-option:hover .radio-input:checked + .radio-custom .radio-dot {
  background: #1E4670;
}

.scale-number {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666;
}
</style>
